module.exports = __webpack_public_path__ + "static/media/xfinity-sell-spa.77c2e55c.png";